import React from 'react';
import { useParams, Link } from 'react-router-dom';
import Hero from '../../components/ui/Hero';
import { blogPosts } from '../../utils/blogPosts';

const BlogPostPage = () => {
  const { slug } = useParams<{ slug: string }>();
  const post = blogPosts.find(p => p.slug === slug);

  if (!post) {
    return (
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-content-primary mb-4">
            Blog post not found
          </h2>
          <Link
            to="/community/blog"
            className="text-brand hover:text-brand-light"
          >
            Back to Blog
          </Link>
        </div>
      </div>
    );
  }

  const BlogPostComponent = post.component;

  return (
    <div>
      <Hero
        title={post.title}
        description={post.excerpt}
        compact
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <BlogPostComponent />
      </div>
    </div>
  );
};

export default BlogPostPage;